import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

import 'normalize.css/normalize.css'; //css resets
import '@/styles/index.scss'; // global css

import './icons'; //icon
import mixin from './utils/globalMixins'; //全局mixins
// import 'amfe-flexible';
Vue.mixin(mixin);

import './permission'; // 路由导航守卫

import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
Vue.use(Antd);

import config from '@/config/index';

Vue.use(config);

import scrollBar from '@/components/scrollBar';
import '@/components/scrollBar/index.scss';
Vue.component('scroll-bar', scrollBar);

// import { mockXHR } from '../mock';
// if (process.env.NODE_ENV === 'production') {
//   mockXHR();
// }

import loading from '@/components/loading/loading'; // 引入loading
Vue.use(loading); // 全局使用loading

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
